import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers, queryParameters } from "../module_auth/AuthService"
import { PaginationCustom } from "../component/common/PaginationCustom"
import { NewsCard } from "./NewsCard"
import { useNavigate } from "react-router-dom"
import { isValidSearchPage } from './common/BaseUtil';
import { useLocation } from "react-router-dom";
import { sendGoogleAnalytics } from "./common/BaseUtil"
import { Helmet } from 'react-helmet';

export function NewsList() {
    const navigate = useNavigate();

    const location = useLocation();
    
    const [newsList, setNewsList] = useState([]);

    ////pagination
    const [pageList, setPageList] = useState([]);
    const [lastPage, setLastPage] = useState();
    const [activePageIndex, setActivePageIndex] = useState();
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const page = queryParameters.get("page")
    const next = queryParameters.get("next")
    const previous = queryParameters.get("previous")
    ////pagination

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)

        //currentPage
        let currentPage
        if(!isValidSearchPage(page)){
            let localStoragePage = localStorage.getItem("page")
            currentPage = !isValidSearchPage(localStoragePage) ? "1" : localStorage.getItem("page")
        } else {
            currentPage = page == "0" ? "1" : page
        }
        setCurrentPage(currentPage)
        //end currentPage

        navigate("/news_list?page="  + currentPage);
        localStorage.setItem("page", currentPage)
        let url = basePort + '/get/news/list/' + currentPage
        //10페이지 이후의 페이지네이션 개발필요
        let activePageIndex = (currentPage-1)%10
        if(next != null){
            url = basePort + '/get/news/list/next/' + currentPage
            activePageIndex = (currentPage-1)%10
        } else if(previous != null) {
            url = basePort + '/get/news/list/previous/' + currentPage
            activePageIndex = (currentPage-1)%10
        }
        
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
            setNewsList(response.cardList)
            
            ////pagination
            setPageList(response.displayPages)
            setLastPage(response.lastPage)
            setActivePageIndex(activePageIndex)
            ////pagination

          }).catch(error => console.log(error))
    }, []);

    return (
        <div>
            <Helmet>
                <title>지워커 | 독일뉴스 최신 업데이트</title>
                <meta name="description" content="독일에 거주하는 한국인을 위한 최신 뉴스와 생활 정보, 정책 소식, 사회 변화를 빠르게 제공합니다." />
                <meta name="keywords" content="독일뉴스, 독일한인교민, 독일최신정보, 독일정책, 독일사회변화" />
                <link rel="canonical" href={`https://www.g-worker.co.kr/news_list?page=${currentPage}`} />
                <meta property="og:title" content="지워커 | 독일뉴스 최신 업데이트" />
                <meta property="og:description" content="독일 거주 한국인을 위한 뉴스, 정책, 사회, 경제 정보를 확인하세요." />
                <meta property="og:url" content={`https://www.g-worker.co.kr/news_list?page=${currentPage}`} />
                {currentPage > 1 && <link rel="prev" href={`https://www.g-worker.co.kr/news_list?page=${currentPage-1}`} />}
                {currentPage < lastPage && <link rel="next" href={`https://www.g-worker.co.kr/news_list?page=${currentPage+1}`} />}
            </Helmet>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>독일뉴스</span></li>
                        </ol>
                    </div>
                    <div class="container">
                        <div className="dynamic-list">
                            {newsList.map((object, index) => (
                                <article key={index}>
                                    <NewsCard object={object} index={index}/>
                                </article>
                            ))}
                        </div>
                    </div>
                    
                    <PaginationCustom 
                        lastPage={lastPage}
                        page={page}
                        pageList={pageList}
                        activePageIndex={activePageIndex}
                        url={'news_list'}
                    />

                </section>
            </main>
        </div>
    );
}